import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import { provide, watch, ref, onBeforeMount, computed, onMounted } from 'vue';
import { useRoute } from "vue-router";
import { useHead } from '@vueuse/head';
import store from '@/store';
import TopNav from "@/components/top-nav";
import Sidebar from "@/components/sidebar";
import VideoDetail from "@/components/video-detail";
import SvgIcon from "@/components/modules/svg-icon";
import GoTop from "@/components/modules/go-top";
import { memberService, languageService } from "@/utils";
import Login from './components/login.vue';
import { UtilityService } from "@/utils";
export default {
  components: {
    TopNav,
    Sidebar,
    SvgIcon,
    VideoDetail,
    GoTop,
    Login
  },
  setup() {
    provide('store', store);
    const route = useRoute();
    const isShowDetail = ref(false);
    const {
      getLocaleMessege,
      getCountryCode,
      getLanguage
    } = languageService;
    const {
      videoType
    } = UtilityService;
    const isNotAuth = computed(() => store.member.states.isNotAuth);
    const meta = computed(() => {
      const metaTable = {
        "/home/iclone": getLocaleMessege("HOME_EXPLORER").META.ICLONE,
        "/home/character-creator": getLocaleMessege("HOME_EXPLORER").META.CHARACTER_CREATOR,
        "/home/cartoon-animator": getLocaleMessege("HOME_EXPLORER").META.CARTOON_ANIMATOR,
        "/home/actorcore": getLocaleMessege("HOME_EXPLORER").META.ACTORCORE,
        "/home/smart-gallery": getLocaleMessege("HOME_EXPLORER").META.SMART_GALLERY,
        "/history": getLocaleMessege("HISTORY").META,
        "/library": getLocaleMessege("LIBRARY").META,
        "/master-class": getLocaleMessege("PAGE_MASTER_CLASS").META,
        "/webinar": getLocaleMessege("WEBINAR").META,
        "/online-manual": getLocaleMessege("ONLINE_MANUAL").META,
        "/bookmark": getLocaleMessege("BOOKMARK").META,
        "/": getLocaleMessege("HOME").META
      };
      const [path, meta] = Object.entries(metaTable).find(([key, _]) => {
        const regex = new RegExp(`^${key}`);
        return regex.test(route.path);
      });
      return {
        ...meta,
        path
      };
    });
    const currentLang = computed(() => getLanguage());
    memberService.loadLoginInfo();
    useHead({
      title: computed(() => meta.value.TITLE),
      meta: [{
        name: "description",
        content: computed(() => meta.value.DESCRIPTION)
      }, {
        name: "language",
        content: computed(() => getCountryCode())
      }, {
        property: "og:title",
        content: computed(() => meta.value.OG_TITLE)
      }, {
        property: "og:description",
        content: computed(() => meta.value.OG_DESCRIPTION)
      }, {
        property: "og:url",
        content: process.env.VUE_APP_WEBSITE_URL + computed(() => meta.value.path)
      }]
    });
    const checkDetailDisplayByRoute = () => {
      const routeNameExcludeLang = route.path.toLocaleLowerCase().replace(new RegExp(currentLang.value + "/"), "").split("/").slice(1);
      isShowDetail.value = route.query.v !== undefined && routeNameExcludeLang[0] !== videoType.skillPath.category;
    };
    const initRlTopnavBanner = () => {
      if (window.rlTopNavBanner) {
        const webTypeRegExp = {
          www: /^https?:\/\/(\w*-)?www\.reallusion\.com\//i,
          wwwIC: /^https?:\/\/(\w*-)?www\.reallusion\.com\/((tw|cn|de|jp)\/)?iclone\/.*/i,
          wwwCC: /^https?:\/\/(\w*-)?www\.reallusion\.com\/((tw|cn|de|jp)\/)?character-creator\/.*/i,
          wwwCTA: /^https?:\/\/(\w*-)?www\.reallusion\.com\/((tw|cn|de|jp)\/)?cartoon-animator\/.*/i,
          productDefault: /^https?:\/\/(\w*-)?www\.reallusion\.com\/((tw|cn|de|jp)\/)?(default.html)?((#|\?).*)?$/i,
          apDefault: /^https?:\/\/(\w*-)?www\.reallusion\.com\/((tw|cn|de|jp)\/)?((iclone|character-creator|cartoon-animator)\/)(default.html)?((#|\?).*)?$/i,
          member: /^https?:\/\/(\w*-)?www\.reallusion\.com\/member\//i,
          contentStore: /^https?:\/\/(\w*-)?www\.reallusion\.com\/contentstore\//i,
          contentStoreIC: /^https?:\/\/(\w*-)?www\.reallusion\.com\/contentstore\/.*\?.*menuitem=ic_.*$/i,
          contentStoreCC: /^https?:\/\/(\w*-)?www\.reallusion\.com\/contentstore\/.*\?.*menuitem=cc_.*$/i,
          contentStoreCTA: /^https?:\/\/(\w*-)?www\.reallusion\.com\/contentstore\/.*\?.*menuitem=cta_.*$/i,
          apStore: /^https?:\/\/(\w*-)?www\.reallusion\.com\/store\//i,
          apStore3D: /^https?:\/\/(\w*-)?www\.reallusion\.com\/store\/.*\?.*p=3d.*$/i,
          apStore2D: /^https?:\/\/(\w*-)?www\.reallusion\.com\/store\/.*\?.*p=cta.*$/i,
          reallusiontv: /^https?:\/\/(\w*-)?www\.reallusion\.com\/reallusiontv\//i,
          hub: /^https?:\/\/(\w*-)?www\.reallusion\.com\/hub\//i,
          smartgallery: /^https?:\/\/(\w*-)?www\.reallusion\.com\/smartgallery\//i,
          marketplace: /^https?:\/\/(\w*-)?(marketplace|city)\.reallusion.com\//i,
          marketplaceIC: /^https?:\/\/(\w*-)?(marketplace|city)\.reallusion\.com\/iclone\/.*$/i,
          marketplaceCC: /^https?:\/\/(\w*-)?(marketplace|city)\.reallusion\.com\/character-creator\/.*$/i,
          marketplaceCTA: /^https?:\/\/(\w*-)?(marketplace|city)\.reallusion\.com\/cartoon-animator\/.*$/i,
          developer: /^https?:\/\/(\w*-)?developer\.reallusion.com\//i,
          store: /^https?:\/\/(\w*-)?(store|storefailover)\.reallusion\.com\//i,
          storeWishList: /^https?:\/\/(\w*-)?(store|storefailover)\.reallusion\.com\/member\/wishlist\.html((#|\?).*)?$/i,
          mocap: /^https?:\/\/(\w*-)?mocap\.reallusion\.com\//i,
          course: /^https?:\/\/(\w*-)?courses\.reallusion\.com\//i
        };
        window.rlTopNavBanner.init(window.rlServerURL, webTypeRegExp);
      }
    };
    watch(() => route.query, () => {
      checkDetailDisplayByRoute();
    });
    watch(() => route.path, () => {
      initRlTopnavBanner();
    });
    onBeforeMount(() => {
      checkDetailDisplayByRoute();
    });
    onMounted(() => {
      initRlTopnavBanner();
    });
    return {
      isNotAuth,
      isShowDetail
    };
  }
};